import {createAction, props} from '@ngrx/store';
import {
  IMultiSelectRequest,
  IMultiSelectResponse,
  ISelectRequest,
  ISelectResponse,
} from '../../models/dynamic-form.model';

export enum DynamicFormActions {
  MultiSelect = '[MultiSelect Component] MultiSelect',
  MultiSelectSuccess = '[MultiSelect Effects] MultiSelect Success',
  MultiSelectFailure = '[MultiSelect Effects] MultiSelect Failure',
  MultiSelectError = '[MultiSelect Effects] MultiSelect Error',
  Select = '[Select Component] Select',
  SelectSuccess = '[Select Effects] Select Success',
  SelectFailure = '[Select Effects] Select Failure',
  SelectError = '[Select Effects] Select Error',
}
export const multiSelectAction = createAction(
  DynamicFormActions.MultiSelect,
  props<{request: IMultiSelectRequest; formControlName: string}>()
);
export const multiSelectEffectSuccess = createAction(
  DynamicFormActions.MultiSelectSuccess,
  props<{response: IMultiSelectResponse; formControlName: string}>()
);
export const multiSelectEffectFailure = createAction(
  DynamicFormActions.MultiSelectFailure,
  props<{reason: string; formControlName: string}>()
);
export const multiSelectEffectError = createAction(
  DynamicFormActions.MultiSelectError,
  props<{error: string; formControlName: string}>()
);

export const selectAction = createAction(
  DynamicFormActions.Select,
  props<{request: ISelectRequest; formControlName: string}>()
);
export const selectEffectSuccess = createAction(
  DynamicFormActions.SelectSuccess,
  props<{response: ISelectResponse[]; formControlName: string}>()
);
export const selectEffectFailure = createAction(
  DynamicFormActions.SelectFailure,
  props<{reason: string; formControlName: string}>()
);
export const selectEffectError = createAction(
  DynamicFormActions.SelectError,
  props<{error: string; formControlName: string}>()
);
